import Context from 'managers/Context';
import { FuzzyMap } from 'utils/fuzzy';
import { getLiteral } from 'utils/getLiteral';

export default class CampaignsMarketingManager {
    getFilterSchema = () => {
        const state = Context.store.getState();
        const currentUser = `${state.config.userData.nombre} ${state.config.userData.apellidos}`;

        return [
            {
                id: 'statusId',
                dataType: 'singleValueList',
                description: getLiteral('label_status'),
                fieldConfiguration: 'statusId',
                inputAttrs: {
                    list: 'tblCampaignsStatuses',
                },
                hint: getLiteral('action_select'),
            },
            {
                id: 'auditModifiedUser',
                dataType: 'singleValueList',
                description: getLiteral('label_user_last_modification'),
                fieldConfiguration: 'auditModifiedUser',
                inputAttrs: {
                    ...FuzzyMap.viewusuariosfullname,
                    defaultSearch: currentUser,
                },
                hint: getLiteral('action_searchowner'),
            },
            {
                id: 'fcreado',
                description: getLiteral('label_created_date'),
                dataType: 'date',
                isAudit: true,
                locators: {
                    first: 'campaigns-marketing-filter__creation-date-start',
                    last: 'campaigns-marketing-filter__creation-date-end',
                },
            },
            {
                id: 'fmodificado',
                description: getLiteral('label_modified'),
                dataType: 'date',
                isAudit: true,
                locators: {
                    first: 'campaigns-marketing-filter__modified-date-start',
                    last: 'campaigns-marketing-filter__modified-date-end',
                },
            },
            {
                id: 'campaignStartDate',
                dataType: 'date',
                description: getLiteral('label_sent_date'),
                fieldConfiguration: 'campaignStartDate',
                serverKeys: { from: 'campaignStartDateFrom', to: 'campaignStartDateTo' },
                customDateFormatToParams: 'YYYY-MM-DD',
                locators: {
                    first: 'campaigns-marketing-filter__send-date-start',
                    last: 'campaigns-marketing-filter__send-date-end',
                },
            },
            {
                id: 'contacts',
                dataType: 'singleValueList',
                description: getLiteral('label_contact'),
                fieldConfiguration: 'contacts',
                inputAttrs: {
                    ...FuzzyMap.contactos,
                },
            },
        ];
    };
}
